<template>
    <div class="item-wrap ticket-tab-wrap pos-r">
        <scroller ref="infinite" class="scroller" :on-refresh="_onRefresh" :on-infinite="_onEndReached" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''">
            <div class="list-wrap user-list-wrap">
                <my-ticket-item :item="item" v-for="(item, index) in dataSources" :key="index" :status="status" @onRefresh="_onRefresh" />
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </div>
        </scroller>
        <div class="btn-wrap pos-f z999" v-if="status == Constants.TICKET_STATUS0">
            <div class="btn-item" @click="isShowSendAction = true">发放门票</div>
        </div>
        <van-action-sheet v-model="isShowSendAction" title="发放详情">
            <div class="send-content-wrap">
                <div class="content-item-wrap flex rcs">
                    <div class="item-title">所属沙龙：</div>
                    <div class="item-con-wrap" @click="_onShowSalonPopup">
                        <div class="value">{{selectSalonItem.name || '请选择(选填)'}}</div>
                    </div>
                </div>
                <div class="content-item-wrap flex rcs">
                    <div class="item-title">发放数量：</div>
                    <div class="item-con-wrap">
                        <van-stepper v-model="formData.num" min="0" :max="item.count" />
                    </div>
                </div>
                <div class="content-item-wrap flex rcs">
                    <div class="item-title">消耗名额：</div>
                    <div class="item-con-wrap">{{ formData.num }}个</div>
                </div>
                <div class="content-item-wrap flex rss mt-1">
                    <div class="item-title">发放描述：</div>
                    <div class="item-con-wrap text-area-wrap">
                        <textarea class="text-area-item" v-model="formData.desc" :placeholder="giftCopy.desc"></textarea>
                    </div>
                </div>
                <div class="remark-wrap">{{ giftCopy.remark }}</div>
                <div class="btn-item submit-btn-item" @click="_onSubmitSend">确定</div>
            </div>
        </van-action-sheet>
        <van-dialog v-model="isShowSalonPopup" title="选择沙龙" show-cancel-button @cancel="selectSalonItem = {}">
            <div class="dialog-content-wrap over-ys">
                <van-radio-group v-model="selectSalonItem.id">
                    <van-cell-group inset class="salon-item-wrap">
                        <van-cell v-for="(item, index) in salonDataSources" :key="index" :title="item.name" clickable @click="_onPressSalonItem(item)">
                            <template #right-icon>
                                <van-radio :name="item.id" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import myTicketItem from "../item/myTicketItem";
export default {
    name: "MyTicketTab",
    props: ["item", "status", "active"],
    components: {
        myTicketItem,
    },
    computed: {},
    watch: {
        active() {
            console.log('this.active---->', this.active);
            this._onRefresh();
        }
    },
    data() {
        return {
            loading: true,
            isShowSendAction: false,
            isShowSalonPopup: false,
            dataSources: [],
            page: 1,
            limit: 10,
            formData: {
                num: 0,
                desc: "",
            },
            giftCopy: {
                desc: "领取后，可立即解锁众修课程，快来领取吧",
                remark: "注:1用户领取成功后才扣名额，分享出去不会马上扣名额，24小时内可领取。\r\n2、没有推荐人，或者推荐人是您，且满足上面可领条件的用户，才可以领取。",
            },

            selectSalonItem: {},
            salonDataSources: [
                // { id: 1, name: 1 },
                // { id: 2, name: 2 },
                // { id: 3, name: 3 },
                // { id: 4, name: 4 },
                // { id: 5, name: 5 },
                // { id: 6, name: 6 },
                // { id: 7, name: 7 },
                // { id: 8, name: 8 },
                // { id: 9, name: 9 },
                // { id: 10, name: 10 },
                // { id: 11, name: 11 },
                // { id: 12, name: 12 },
                // { id: 13, name: 13 },
                // { id: 14, name: 14 },
                // { id: 15, name: 15 },
                // { id: 16, name: 16 },
            ],
        };
    },
    mounted() {
        this._requestDataSources();
        this._requestSalonDataSources();
    },
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                };
            }
            this.$router.push({
                path,
                query,
            });
        },

        _onPressToWeb(url) {
            if (!url) return;
            console.log("url---->", url);
            window.location.href = url;
        },

        _onShowSalonPopup() {
            this.isShowSalonPopup = true;
            
            // if (this.salonDataSources.length < 1) {
            //     return this.AlertManager
            //         .confirm({
            //             title: '温馨提示',
            //             confirmButtonText: '去发布',
            //             message: '您还没有进行中的沙龙，是否立即发布'
            //         })
            //         .then(() => {
            //             this._onPressToNavigate('', 'addSalon');
            //         })
            //         .catch(() => {
            //             // on cancel
            //         });
            // } else {
            //     this.isShowSalonPopup = true;
            // }
        },

        _onPressSalonItem(item) {
            console.log('item---->', item);
            this.selectSalonItem = item;
        },

        async _requestDataSources() {
            let {
                status,
                dataSources
            } = this;
            let url = this.API.user_ticket_list;
            let data = {
                status,
                page: this.page,
                limit: this.limit,
            };
            try {
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.dataSources.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList;
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.dataSources = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                this._onStopLoading(true);
            }
        },

        async _requestSalonDataSources() {
            let url = this.API.salon_my_salon;
            let data = {
                limit: 999999,
                user_type: 'agent',
                status: this.Constants.SALON_STATUS2,
            };
            try {
                const result = await this.$post(url, data);
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.salonDataSources = result.data.list || [];
                }
            } catch (error) {
                console.log('error---->', error);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
            this.$emit('onRefresh', 1);
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log("status---->", status);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },

        async _onSubmitSend() {
            let url = this.API.ticket_grant_ticket;
            let data = {
                ...this.formData,
                salon_id: this.selectSalonItem.id,
            };
            // if (!data.salon_id) return this.ToastManager('请选择相应沙龙');
            if (data.num < 1) return this.ToastManager("请设置发放数量");
            data.desc = data.desc || this.giftCopy.desc;
            const result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this._onPressToNavigate("", "myTicketGift", {
                    ...result.data,
                });
            } else {
                this.ToastManager(result.msg);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.ticket-tab-wrap {
    height: calc(100vh - 5rem - 4.4rem);

    .user-list-wrap {
        margin-top: 1rem;
    }

    .btn-wrap {
        width: 100%;
        bottom: 0;
        overflow: hidden;

        .btn-item {
            color: #fff;
            height: 4rem;
            border-radius: 5px;
            margin: 1rem 15px 2rem;
            box-shadow: 0 0 1px 0px #6c6c6c61;
            background: linear-gradient(45deg, #7180eb, #acb5f0);
        }
    }

    .send-content-wrap {
        padding: 2rem 2rem;
        border-top: 1px solid #ddd;
        min-height: 22rem;

        .content-item-wrap {
            min-height: 4rem;

            .item-title {
                font-size: 1.4rem;
                width: 8rem;
            }

            .item-con-wrap {
                flex: 1;

                &.text-area-wrap {
                    min-height: 5rem;
                    border-radius: 5px;
                    padding: 0.5rem 1rem;
                    border: 1px solid #ddd;
                }

                .text-area-item {
                    border: 0;
                    width: 100%;
                    height: 100%;
                    font-size: 1.3rem;
                }
            }
        }

        .remark-wrap {
            color: #999;
            margin-top: 2rem;
            line-height: 1.5;
            font-size: 1.2rem;
            white-space: pre-wrap;
        }

        .submit-btn-item {
            height: 4rem;
            color: #fff;
            margin: 3rem auto;
            border-radius: 5px;
            background: linear-gradient(45deg, #7180eb, #acb5f0);
        }
    }

    .dialog-content-wrap {
        margin-top: 15px;
        max-height: 60vh;
        min-height: 10vh;

        .salon-item-wrap {
            &:last-of-type::after {
                border-bottom: 0;
            }
        }
    }
}
</style>